import {
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';

import { useNavigate } from 'react-router-dom';

import { Button } from '../../components/button';
import { ErrorBox } from '../../components/error-box';
import { Loader } from '../../components/loader';
import { useCodeParam } from '../../hooks/use-code-param';
import { useAuthVerify } from '../../queries/useAuthVerify';
import { useStore } from '../../store/store';
import { ROUTES } from '../routes-map';

export const VerificationRoute = () => {
    const shouldVerify = useRef(true);

    const [state, setState] = useState<
        'initial' | 'loading' | 'success' | 'error'
    >('initial');

    const authVerify = useAuthVerify();

    const navigate = useNavigate();

    const { code } = useCodeParam();

    const { loginSessionId, setUserData } = useStore(
        (state) => ({
            loginSessionId: state.loginSessionId,
            setUserData: state.setUserData,
        }),
    );

    const handleVerify = useCallback(async () => {
        try {
            setState('loading');
            shouldVerify.current = false;

            const response = await authVerify.mutateAsync({
                data: {
                    code,
                    loginSessionId,
                },
            });

            setUserData({
                personNumber: response.ssn,
            });

            navigate(ROUTES.TUSEN_TAKK.path);
        } catch (error: any) {
            setState('error');
            console.error(error);
        }
    }, [authVerify, code, loginSessionId, navigate, setUserData]);

    useEffect(() => {
        if (
            code &&
            loginSessionId &&
            state === 'initial' &&
            shouldVerify.current
        ) {
            handleVerify();
        }
    }, [code, loginSessionId, state, handleVerify]);

    if (state === 'error') {
        return (
            <ErrorBox>
                <a href="https://www.eiendomsfinans.no/">
                    <Button variant="primary">Avslutt</Button>
                </a>
            </ErrorBox>
        );
    }

    if (state === 'loading' || state === 'success') {
        return (
            <div style={{ textAlign: 'center' }}>
                Når du bekrefter påloggingsinformasjonen din, kan dette ta en
                stund, vennligst ikke lukk dette vinduet.
                <Loader />
            </div>
        );
    }

    return null;
};
